import React, { useMemo } from 'react';
import { BRAND_FEATURES, COPYRIGHT_INFO } from '../constants';
import logo from '../../../../public/asset/images/logo.svg';

/**
 * 品牌展示组件
 * 使用常量配置和性能优化
 */
const BrandDisplay = React.memo(() => {
  // 使用常量配置的品牌特色
  const features = BRAND_FEATURES;
  
  // 使用useMemo优化版权信息计算
  const copyrightText = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return `版权所有：${COPYRIGHT_INFO.START_YEAR}-${currentYear}©: ${COPYRIGHT_INFO.COMPANY} ${COPYRIGHT_INFO.ICP}`;
  }, []);

  return (
    <div className='hidden lg:block'>
      <div className='flex flex-col justify-between'>
        {/* 品牌Logo */}
        <div className='flex flex-row items-center'>
          <img 
            className="w-16 h-16 rounded-2xl border-4 border-[#C16F8E]" 
            src={logo} 
            alt="贯石科技Logo"
          />
          <span className='text-3xl text-white ml-4'>贯石科技</span>
        </div>
        
        {/* 品牌特色 */}
        <div className='flex flex-col w-8/12 my-32'>
          {features.map((feature, index) => (
            <div key={index}>
              <span className='text-4xl font-bold text-white leading-[56px]'>丨</span>
              <span className='text-4xl font-bold text-white leading-[56px] mx-11'>{feature.text}</span>
              <span className='text-4xl font-bold text-white leading-[56px]'>丨</span>
            </div>
          ))}
          <span className='text-xl text-white mt-4'>
            为企业提供高端软件定制开发及互联网解决方案服务
          </span>
        </div>
        
        {/* 版权信息 */}
        <span className='text-sm text-white'>
          {copyrightText}
        </span>
      </div>
    </div>
  );
});

BrandDisplay.displayName = 'BrandDisplay';

export default BrandDisplay;